// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"601":"4bd89b37","798":"b043b24a","861":"128ff249"}[chunkId] + ".chunk.js";
};